import { render, staticRenderFns } from "./breadcrumb.component.vue?vue&type=template&id=b9bc99be&scoped=true"
import script from "./breadcrumb.component.vue?vue&type=script&lang=js"
export * from "./breadcrumb.component.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.component.vue?vue&type=style&index=0&id=b9bc99be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bc99be",
  null
  
)

export default component.exports